import React, { useEffect, useState } from "react";
import { StatusCode } from "api/protocols";
import "./unsubscribeNewsletter.scss";
import Spin from "components/spin/spin";
import FeatureIcon from "components/icon/FeatureIcon";
import { PutGuestUnsubscribeNewsLetter } from "api/rpc/2024-04/guest/newsletter/newsletter";
import { useTranslation } from "react-i18next";

interface IState {
  cancelSuccess: boolean;
}

export default function UnsubscribeNewsletter() {
  const [state, setState] = useState<IState>({
    cancelSuccess: undefined,
  });
  const {t} = useTranslation();

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");

  useEffect(() => {
      if (token) {
        void handleUnsubscribe();
      } else {
        setState(prevState => ({ ...prevState, cancelSuccess: false }));
      }
    
  }, []);

  async function handleUnsubscribe() {
    const res = await PutGuestUnsubscribeNewsLetter({ unsubscribe_token: token }, true);
    setState(prevState => ({ ...prevState, cancelSuccess: res.status === StatusCode.OK }));
  }

  return (
    <div className="unsubscribe-newsletter-cancel-parent-container">
      <div className="unsubscribe-newsletter-cancel-inner-container">
        {state.cancelSuccess === undefined ? (
          <div style={{ height: "50px", width: "50px" }}>
            <Spin />
          </div>
        ) : (
          <div className="unsubscribe-newsletter-group">
            {state.cancelSuccess ? (
              <FeatureIcon type="success" theme="light-circle-outline" size="large" icon="check" />
            ) : (
              <FeatureIcon type="error" theme="light-circle-outline" size="large" icon="exclamation-triangle" />
            )}
            <p className={"cancel-title"}>{state.cancelSuccess ? t("Success") : t("Error")}</p>
            <p className="cancel-subtext">
              {state.cancelSuccess
                ? t("You have successfully unsubscribed from the newsletter")
                : t("There was an error with your request")}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
